<script setup lang="ts">
import type { JobItem, JobItemPlatform } from '~/models/Job'
import { useUser } from '~/store/user'

const props = defineProps<{
  job: JobItem
  item: JobItemPlatform
}>()
const emit = defineEmits(['applyClicked'])
const config = useRuntimeConfig()
const user = useUser()
const route = useRoute()
const redirect = useCookie('redirect', { path: '/', domain: config.public.COOKIE_DOMAIN })
const isClient = process.client
const token = computed(() => {
  if (!user.token)
    redirect.value = route.fullPath
  return user.token
})
const platform = computed(() => {
  return usePlatforms(props.item.name)
})

function applyAction() {
  // set tracking
  const inDashboard = route?.path.includes('dashboard/job-recommendation')
  useSetTracking(inDashboard ? 'job_recommendation_result_apply' : 'job_page_apply', { job_apply_option: props.item?.name || '', job_location: !isEmpty(props.job?.locations) ? `${props.job?.locations[0]?.city || ''}, ${props.job?.locations[0]?.country || ''}` : 'null', job_title: props.job?.cleaned_title || '' })
  if (token.value)
    saveApplication()
}

async function saveApplication() {
  let resStatus = null
  const payload = {
    jobId: props.job.job_id,
    score: props.job.score || 0,
  }

  try {
    const { data, error } = await useResumeApi('/applications', {
      method: 'POST',
      body: payload,
      lazy: true,
      useApiKey: true,
      initialCache: false,
      key: 'submit_application',
      async onResponse({ response }) {
        resStatus = response.status
      },
    })
  }
  catch (err) {
    console.error(err)
  }
}
</script>

<template>
  <BaseAtomsButton tag="a" outline :href="((token && isClient) || !isClient) ? `/redirect/apply?url=${props.item.apply_url}&platform=${props.item.name}` : '#'" :target="((token && isClient) || !isClient) ? '_blank' : ''" size="sm" classes="border-0 bg-[#EEF2FF] text-sm text-[#5843E5] py-2.5 px-4" @click="token ? applyAction() : emit('applyClicked')">
    <div class="flex-shrink-0 flex justify-center w-full items-center font-bold">
      <span class="capitalize inline-block">{{ platform?.name ? useTextCapitalize(platform?.name.replaceAll('_', ' ')) : useTextCapitalize(item.name.replaceAll('_', ' ')) }}</span>
      <Icon name="majesticons:open" class="w-5 h-5 ml-auto" />
    </div>
  </BaseAtomsButton>
</template>
